"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultUIConfig = void 0;
/**
 * 推导 schema 的默认 UI 配置，这里返回的 DataUIConfig 对象里 `type` 一定是存在的
 */
function getDefaultUIConfig(schema) {
    const ans = Object.assign({}, (schema === null || schema === void 0 ? void 0 : schema.ui) || {});
    if (schema.enum || schema.enumExpr) {
        ans.type = "select";
    }
    else {
        switch (schema.type) {
            case "boolean":
                ans.type = "checkbox";
                break;
            case "object":
                ans.type = "basicForm";
                break;
            case "array":
                ans.type = "arrayTable";
                break;
            case "number":
                ans.type = "numberInput";
                break;
            case "string":
                ans.type = "textInput";
                break;
            case "integer":
                ans.type = "numberInput";
                break;
        }
    }
    return ans;
}
exports.getDefaultUIConfig = getDefaultUIConfig;
//# sourceMappingURL=ui.js.map